<template>
  <div class="promotion_update">
    <div class="breadcrumb">
      <h1 style="color: #ac8400">Edit Promotion</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #f2f2f2">
      <router-link to="/dashboard"> Dashboard </router-link>
      /

      <b>Marketing</b> /

      <router-link to="/promotion"> Promotions </router-link>
      /

      <b>Update</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <form class="form" @submit.prevent="handleSubmit">
      <fieldset>
        <legend>Promotion Details</legend>
        <div class="form-group">
          <label>Title</label>
          <input v-model="promotion.title" class="form-control" />
        </div>

        <div class="form-group">
          <label>Description</label>
          <textarea v-model="promotion.content" class="form-control"></textarea>
        </div>

        <!-- <div class = "form-group">
					<label>Start Time</label>
					<input type = "date" step = "1" v-model = "promotion.start_time" class = "form-control">
				</div>

				<div class = "form-group">
					<label>End Time</label>
					<input type = "date" step = "1" v-model = "promotion.end_time" class = "form-control">
				</div> -->

        <div class="form-group">
          <br />
          <br />

          <label>Upload Image Link</label>
          <input
            type="file"
            id="file"
            ref="file"
            v-on:change="handleFileUpload"
            class="form-control"
          />
          <br />
          <progress max="100" :value.prop="uploadPercentage"></progress>
        </div>

        <div class="form-group">
          <small>
            <b>{{ promotion.created_at | moment("Do MMMM YYYY, h:mm a") }}</b>
          </small>
        </div>

        <input type="submit" class="btn btn-primary" />
      </fieldset>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "promotion_update",

  data() {
    return {
      promotion: {
        staff: {
          user: {
            name: "",
            email: "",
          },
        },
      },
      file: "",
      uploadPercentage: 0,
    };
  },

  methods: {
    loadPromotionDetails() {
      let token = localStorage.getItem("token");
      this.id = this.$route.params.id;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("promotions/show/" + this.id, {
            headers: {
              Authorization: "Bearer " + token,
            },
          })
          .then((res) => {
            this.promotion = res.data;

            this.promotion.start_time = moment(
              this.promotion.start_time
            ).format("YYYY-MM-DD[T]HH:mm:ss");
            this.promotion.end_time = moment(this.promotion.end_time).format(
              "YYYY-MM-DD[T]HH:mm:ss"
            );
          });
      }
    },

    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },

    handleSubmit() {
      this.updatePromotion();
    },

    updatePromotion() {
      let token = localStorage.getItem("token");
      this.id = this.$route.params.id;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        let formdata = new FormData();
        formdata.append("title", this.promotion.title);
        formdata.append("content", this.promotion.content);
        formdata.append("promotion", this.file);

        axios
          .post("/promotions/update/" + this.id, formdata, {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: function (progressEvent) {
              this.uploadPercentage = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );
            }.bind(this),
          })
          .then((res) => {
            console.log("SUCCESS!!");

            swal({
              text: res.data.message,
              icon: res.data.success ? "success" : 'error',
              button: "OK",
            });

            this.loadPromotionDetails();
          })
          .catch(error => {
            console.log("FAIL!!" + error);

            swal({
              text: "Failed to update information",
              icon: "error",
              button: "OK",
            });
          });
      }
    },
  },

  mounted() {
    this.loadPromotionDetails();
  },
};
</script>
